import React from 'react';
import JobDetailBox from 'components/JobDetailBox';
import './styles.scss';

const JobDetail: React.FC = () => {
	return (
		<div className="right-area flex-1 d-flex flex-column">
			<JobDetailBox />
		</div>
	);
};

export default JobDetail;
